module.exports = __webpack_public_path__ + "static/media/03_Portfolio.f9277f7c.png";